import { MENU_PORTAL_ATTR } from "../components/CategoryMenuPortal/constants";

// classNamePrefix react-select. Единый источник для классов контрола/меню
// (.category-select__control, .category-select__menu) и селектора «своей зоны».
export const CLASS_PREFIX = "category-select";

// «Своя» зона селекта: список (портал [data-category-menu] на десктопе или
// обычное .__menu на мобилке) и контрол с чипами. Скролл/фокус внутри неё не
// должны закрывать меню. data-атрибут берём из MENU_PORTAL_ATTR — чтобы селектор
// не разъехался с порталом при переименовании.
export const OWN_UI_SELECTOR = `[${MENU_PORTAL_ATTR}], .${CLASS_PREFIX}__menu, .${CLASS_PREFIX}__control`;

export const isInsideOwnUi = (node: EventTarget | null): boolean =>
  node instanceof Element && !!node.closest(OWN_UI_SELECTOR);
